const product = document.querySelector(".product");
const productForm = product.querySelector(".product__form");
const options = Array.from(product.querySelectorAll(".product-option"));
const productSwatches = Array.from(
  product.querySelectorAll(".color-swatches .swatch__color")
);
const productSelect = productForm.querySelector(".product__select");
const quantitySelector = productForm.querySelector(".quantity-block");
const decrementButton = quantitySelector.querySelector(".quantity-minus");
const incrementButton = quantitySelector.querySelector(".quantity-plus");
const quantityInput = quantitySelector.querySelector("input.quantity");
const productFormAddToCart = productForm.querySelector(".product__addcart");
const typesOptions = product.querySelectorAll(
  ".type-selection .types-selection__wrapper .type-option"
);
const modelInfos = product.querySelectorAll(
  ".product-gallery__main-images .slide-info"
);
const modalTrigger = product.querySelector(".size-guide-trigger");
const sizeModal = product.querySelector(".size-guide__modal");
const modalClose = product.querySelector(".modal__close");

// product form block

function initProductTypes() {
  typesOptions.forEach((type) => {
    type.addEventListener("click", function () {
      removeActive(typesOptions);
      this.classList.add("active");
      document.querySelector(".type-selection .selected_option").innerHTML =
        getActiveType();
      updateSelectedOption(
        getActiveOption(options),
        getActiveSwatch(productSwatches)
      );

      let typesAccordion = document.querySelector(
        ".swiper-wrapper-main .accordions__wrapper .accordion"
      );
      typesAccordion
        .querySelector(".accordion__heading")
        .setAttribute("aria-expanded", "false");
      typesAccordion
        .querySelector(".accordion__content")
        .classList.remove("expanded");
      if (
        typesAccordion.classList.contains("type-selection") &&
        window.matchMedia("(max-width: 990px)").matches
      ) {
        typesAccordion.closest(".absolute-wrapper").style.position = "absolute";
        document.body.classList.remove("overflow");
      }
      typesAccordion.querySelector(".icon").innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">\n' +
        '          <path d="M20 9L12.5 16.5L5 9" stroke="#F9F7F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        "        </svg>";
    });
  });
}

function initColorSwatches() {
  productSwatches.forEach((swatch) => {
    swatch.addEventListener("click", () => {
      const activeOption = getActiveOption(options);
      const activeColor = swatch.dataset.option;
      removeActive(productSwatches);
      swatch.classList.add("active");
      swatch
        .closest(".options-wrapper")
        .querySelector(".options-heading__name .selected_option").innerHTML =
        activeColor;
      updateSelectedOption(activeOption, activeColor);
    });
  });
}

function initOptions() {
  options.forEach((option) => {
    option.addEventListener("click", () => {
      const activeSwatch = getActiveSwatch(productSwatches);
      const activeSize = option.dataset.option;

      removeActive(options);
      option.classList.add("active");
      option
        .closest(".options-wrapper")
        .querySelector(".options-heading__name .selected_option").innerHTML =
        activeSize;
      updateSelectedOption(activeSize, activeSwatch);
    });
  });
}

function getActiveOption(options) {
  if (options.length) {
    const activeOption = options.find((option) =>
      option.classList.contains("active")
    );
    return activeOption
      ? activeOption.dataset.option
      : options[0].dataset.option;
  }
}

function getActiveType() {
  if (productForm.querySelector("#product-type").value === "blank") {
    return "";
  } else {
    return product.querySelector(
      ".type-selection .types-selection__wrapper .type-option.active"
    ).dataset.option;
  }
}

function getActiveSwatch(swatches) {
  if (swatches.length) {
    const activeSwatch = swatches.find((swatch) =>
      swatch.classList.contains("active")
    );
    return activeSwatch ? activeSwatch.dataset.option : "";
  }
}

function updateSelectedOption(size, color) {
  Array.from(productSelect.options).forEach((option) => {
    const { title, price, comparePrice } = option.dataset;

    if (productSelect.dataset.productOptionsSize > 1) {
      const [optionSize, optionColor] = title.split(" / ");

      if (
        (optionSize === size && optionColor === color) ||
        (optionColor === size && optionSize === color)
      ) {
        if (option.dataset.available == "false") {
          productFormAddToCart.innerHTML = "Sold Out";
          productFormAddToCart.disabled = true;
          productFormAddToCart.style.background = "#ffffff";
          productFormAddToCart.style.color = "#1f1d1e";
          $(".btn.klaviyo-bis-trigger").show();
        } else {
          productFormAddToCart.innerHTML = "Add to Cart";
          productFormAddToCart.disabled = false;
          productFormAddToCart.style.background = "#1f1d1e";
          productFormAddToCart.style.color = "#f9f7f6";
          $(".btn.klaviyo-bis-trigger").hide();
        }

        option.selected = true;

      if (comparePrice != "") {
        product.querySelector(".product_price").innerHTML =
          price + " <span class='compare-price'>" + comparePrice + "</span>";
      } else {
        product.querySelector(".product_price").innerHTML = price;
      }

        //product.querySelector(".product_price").innerHTML = price;

        const activeType = getActiveType();
        productForm.querySelector("#product-type").value =
          activeType !== "" ? activeType : "blank";

        let selectedVariantAlt = optionColor;
        if (activeType !== "") {
          selectedVariantAlt = `${optionColor} / ${activeType}`;
        }

        const selectedMainImages = Array.from(
          document.querySelectorAll(
            ".product-gallery__main-images .swiper-slide img"
          )
        ).filter((image) => {
          const alt = image.getAttribute("alt");
          if (alt.includes(" & ")) {
            const matches = alt.split("&")[0].trim();

            return matches && selectedVariantAlt === matches;
          } else {
            return alt === selectedVariantAlt;
          }
        });
        const selectedThumbnails = Array.from(
          document.querySelectorAll(
            ".product-gallery__thumbnails .swiper-slide img"
          )
        ).filter((image) => {
          const alt = image.getAttribute("alt");
          if (alt.includes(" & ")) {
            const matches = alt.split("&")[0].trim();

            return matches && selectedVariantAlt === matches;
          } else {
            return alt === selectedVariantAlt;
          }
        });
        modelInfos.forEach((info) => {
          let alt = info
            .closest(".swiper-slide")
            .querySelector("img")
            .getAttribute("alt");
          let modelName = "";
          let modelSize = "";

          if (alt.includes(" % ")) {
            const matches = alt.split("%")[1].trim();

            modelName = matches.split(" / ")[0];
            modelSize = matches.split(" / ")[1];
          }
          info.style.display = "none";
          info.querySelector(".info__type").style.display =
            modelName === "" ? "none" : "block";
          info.querySelector(".info__size").style.display =
            modelSize === "" ? "none" : "block";
          info.querySelector(".info__type").innerHTML = modelName;
          info.querySelector(".info__size").innerHTML = modelSize;
          info.style.visibility = "visible";
        });

        if (
          selectedMainImages.length !== 0 &&
          selectedThumbnails.length !== 0
        ) {
          hideSlides(
            document.querySelectorAll(
              ".product-gallery__main-images .swiper-slide"
            )
          );
          hideSlides(
            document.querySelectorAll(
              ".product-gallery__thumbnails .swiper-slide"
            )
          );
          showSlides(selectedMainImages);
          showSlides(selectedThumbnails);
          product_thumbnails_slider.update();
          product_gallery_slider.update();
          selectedMainImages[0]
            .closest(".swiper-slide")
            .querySelector(".slide-info").style.display = "block";
        }
      } else {
        option.selected = false;
      }
    } else {
      option.selected = title === size || title === color;
      modelInfos.forEach((info) => {
        info.style.display = "none";
      });
    }
  });
}

function removeActive(elements) {
  elements.forEach((element) => element.classList.remove("active"));
}

function hideSlides(slides) {
  slides.forEach(
    // (slide) => (slide.closest(".swiper-slide").style.display = "none")
    (slide) => {
      slide.closest(".swiper-slide").style.display = "none";
      let temp_arr = [...slide.children][0];
      temp_arr.removeAttribute("data-fancybox");
      // slide.closest(".swiper-slide").classList.remove("fancybox-image");
    }
  );
}

function showSlides(slides) {
  slides.forEach(
    // (slide) => (slide.closest(".swiper-slide").style.display = "block")
    (slide) => {
      slide.closest(".swiper-slide").style.display = "block";
      slide.parentElement.setAttribute("data-fancybox","image-group");
      // slide.closest(".swiper-slide").classList.add("fancybox-image");
    }
  );
}

decrementButton.addEventListener("click", () => {
  const currentValue = parseInt(quantityInput.value);
  if (currentValue > 1) {
    quantityInput.value = currentValue - 1;
  }
});

incrementButton.addEventListener("click", () => {
  const currentValue = parseInt(quantityInput.value);
  quantityInput.value = currentValue + 1;
});

// accordions block
function initAccordions() {
  let accordionTriggers = document.querySelectorAll(
    ".accordions__wrapper .accordion__heading"
  );

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      if (this.getAttribute("aria-expanded") === "true") {
        this.setAttribute("aria-expanded", "false");
        this.closest(".accordion")
          .querySelector(".accordion__content")
          .classList.remove("expanded");

        if (
          this.closest(".accordion").classList.contains("type-selection") &&
          window.matchMedia("(max-width: 990px)").matches
        ) {
          this.closest(".absolute-wrapper").style.position = "absolute";
          document.body.classList.remove("overflow");
        }

        if (this.classList.contains("chevron")) {
          this.querySelector(".icon").innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">\n' +
            '          <path d="M20 9L12.5 16.5L5 9" stroke="#F9F7F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            "        </svg>";
        } else {
          this.querySelector(".icon").innerHTML =
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '            <path d="M3.75 12H20.25" stroke="#1F1D1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '            <path d="M12 3.75V20.25" stroke="#1F1D1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            "        </svg>";
        }
      } else {
        this.setAttribute("aria-expanded", "true");
        this.closest(".accordion")
          .querySelector(".accordion__content")
          .classList.add("expanded");

        if (
          this.closest(".accordion").classList.contains("type-selection") &&
          window.matchMedia("(max-width: 990px)").matches
        ) {
          this.closest(".absolute-wrapper").style.position = "fixed";
          document.body.classList.add("overflow");
        }

        if (this.classList.contains("chevron")) {
          this.querySelector(".icon").innerHTML =
            ' <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
            '          <path d="M4.5 15L12 7.5L19.5 15" stroke="#F9F7F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            "        </svg>";
        } else {
          this.querySelector(".icon").innerHTML =
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '            <path d="M3.75 12H20.25" stroke="#1F1D1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            "        </svg>";
        }
      }
    });
  });
}
if (modalTrigger) {
  modalTrigger.addEventListener("click", function () {
    sizeModal.classList.add("is-shown");
    document.body.classList.add("overflow");
  });

  modalClose.addEventListener("click", function () {
    sizeModal.classList.remove("is-shown");
    document.body.classList.remove("overflow");
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (getActiveType() !== "") {
    document.querySelector(".type-selection .selected_option").innerHTML =
      getActiveType();
  }

  initColorSwatches();
  initProductTypes();
  initOptions();
  initAccordions();
  updateSelectedOption(
    getActiveOption(options),
    getActiveSwatch(productSwatches)
  );
});
